import { Controller } from "@hotwired/stimulus"
import { swapToSpinner, restoreButton } from "./helpers/button_loading"

export default class extends Controller {
  static targets = ["checkInButton", "roomButton", "completeButton"]
  static values = { id: Number }

  async checkIn(event) {
    await this.performAction(event, `/appointments/${this.idValue}/check_in`)
  }

  async room(event) {
    await this.performAction(event, `/appointments/${this.idValue}/status`, { status: "in_room" })
  }

  async complete(event) {
    await this.performAction(event, `/appointments/${this.idValue}/status`, { status: "complete" })
  }

  async performAction(event, url, extraParams = {}) {
    const button = event.currentTarget
    const restore = swapToSpinner(button)

    try {
      const token = document.querySelector('meta[name="csrf-token"]')?.content
      const body = new URLSearchParams(extraParams)

      const response = await fetch(url, {
        method: "PATCH",
        headers: {
          "Accept": "text/vnd.turbo-stream.html",
          "X-CSRF-Token": token,
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: body.toString()
      })

      if (response.ok) {
        const html = await response.text()
        Turbo.renderStreamMessage(html)
      } else {
        restoreButton(button, restore)
      }
    } catch {
      restoreButton(button, restore)
    }
  }
}
